import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { logEvent } from "../../../../utils/analytics";
import { useLatestUpdatesMasterhook } from "../../customHooks";
import templeJson from "../../../../config/temple.json";
import "./latestupdates.css";

const LatestUpdates = () => {
  const { masterData, fetchMasterData } = useLatestUpdatesMasterhook();
  const [scrollers, setScrollers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isCycleComplete, setIsCycleComplete] = useState(false);

  const interval = (masterData?.scrollerConfigs?.interval || 2) * 1000;
  const speed = masterData?.scrollerConfigs?.speed || 5;

  useEffect(() => {
    fetchMasterData();
  }, []);

  useEffect(() => {
    if (masterData?.latestNews?.data?.length) {
      const updated = masterData.latestNews.data.map((item) => ({
        ...item,
        count: item.count || 1,
      }));
      setScrollers(updated);
      setCurrentIndex(0);
      setIsCycleComplete(false);
    }
  }, [masterData]);

  useEffect(() => {
    if (!scrollers.length || isCycleComplete) return;

    const timer = setInterval(() => {
      setScrollers((prevScrollers) => {
        const updated = [...prevScrollers];
        const current = updated[currentIndex];

        // Decrement current item count
        if (current.count > 0) {
          current.count -= 1;
        }

        // If all are now zero, stop
        const allZero = updated.every((item) => item.count === 0);
        if (allZero) {
          setIsCycleComplete(true);
          return updated;
        }

        // Find next index with count > 0
        let nextIndex = currentIndex;
        let tries = 0;
        while (tries < updated.length) {
          nextIndex = (nextIndex + 1) % updated.length;
          if (updated[nextIndex].count > 0) break;
          tries++;
        }

        setCurrentIndex(nextIndex);
        return updated;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [scrollers, currentIndex, interval, isCycleComplete]);

  const currentScroller = scrollers[currentIndex];
  const displayText =
    isCycleComplete || !currentScroller?.count
      ? "No Updates Available"
      : currentScroller?.title;

  return (
    <Box
      padding={1}
      marginBottom={1}
      className={
        templeJson["LatestUpdates"].style === 1
          ? "latest-updates-background-dt"
          : "latest-updates-background-svt"
      }
    >
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={2} display="flex" justifyContent="center">
          <Typography
            variant="h6"
            className={
              templeJson["LatestUpdates"].style === 1
                ? "latest-updates-heading-dt"
                : "latest-updates-heading-svt"
            }
          >
            Latest Update
          </Typography>
        </Grid>

        <Grid item xs={12} md={5}>
          <div className="news-marquee">
            <Typography
              variant="body1"
              className="news-text"
              sx={{
                animation:
                  !isCycleComplete && currentScroller?.count > 0
                    ? `marquee ${speed}s linear infinite`
                    : "none",
              }}
            >
              {displayText}
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={5}>
          <Grid container spacing={1}>
            {[
              "Daily Puja Schedule",
              "Monthly Newsletter",
              "Annual Calendar",
            ].map((label, idx) => (
              <Grid item xs={4} key={idx}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  className={
                    templeJson["LatestUpdates"].style === 1
                      ? "latest-updates-btn-dt"
                      : "latest-updates-btn-svt"
                  }
                  href={masterData?.annualCalendar?.data}
                  target="_blank"
                  onClick={() => logEvent(label, "Clicked")}
                >
                  {label}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LatestUpdates;
